export const tailGasMenuRouter = [{
  path: 'gas/list',
  icon: ' iconfont icongas',
  name: 'tailGasCheck',
  title: '尾气检验单',
  component: () => import('@/views/gip/gas/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/gas/tailGas.js